export enum AvailabilityErrorTypeEnum {
  Generic = 'AM_ERROR',
  ChildHold = 'AM_HOLD',
}
